import { getExerciseTypeVersionAdapter } from '@datacamp/exercise-types';
var exerciseTypeVersionAdapter = getExerciseTypeVersionAdapter('CloudExercise', 'v0');
export default exerciseTypeVersionAdapter;